import { Head } from "@inertiajs/react"
import { useMemo } from "react"
import camelcaseKeys from "camelcase-keys"

import AppLayout from "@/layouts/app-layout"
import { dashboardPath } from "@/routes"
import type { BreadcrumbItem, DashboardProps } from "@/types"
import {
  DashboardHero,
  FlashcardsCard,
  ConversationsCard,
  WordsCard,
  PhrasesCard,
  LanguagePacksCard,
  ComingSoonCard,
} from "@/components/dashboard"

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: "Dashboard",
    href: dashboardPath(),
  },
]

export default function Dashboard(props: any) {
  const { flashcards, conversations, phrases, words, mockStats } = useMemo(
    () => camelcaseKeys(props, { deep: true }) as DashboardProps,
    [props],
  )
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Dashboard" />

      <div className="flex h-full flex-1 flex-col">
        <div className="mx-auto w-full max-w-6xl flex-1 px-4 py-6 sm:px-6 lg:px-8">
          {/* Hero Section */}
          <DashboardHero flashcards={flashcards} mockStats={mockStats} />

          {/* Feature Cards Grid */}
          <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            <ConversationsCard
              conversations={conversations}
              animationDelay={100}
            />
            <FlashcardsCard stats={flashcards} animationDelay={150} />
            <PhrasesCard phrases={phrases} animationDelay={200} />
            <WordsCard words={words} animationDelay={250} />
            <LanguagePacksCard animationDelay={300} />
            <ComingSoonCard animationDelay={350} />
          </div>
        </div>
      </div>
    </AppLayout>
  )
}
